const map =
  <K extends string | number | symbol, V = any>(o: Record<K, V>) =>
  (v: keyof typeof o, default_?: V) =>
    o[v] || default_;

export default map;
